import { render, staticRenderFns } from "./Entities.vue?vue&type=template&id=68bb2869&scoped=true&"
import script from "./Entities.vue?vue&type=script&lang=ts&"
export * from "./Entities.vue?vue&type=script&lang=ts&"
import style0 from "./Entities.vue?vue&type=style&index=0&id=68bb2869&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bb2869",
  null
  
)

export default component.exports